// extracted by mini-css-extract-plugin
export default {"background":"main_background__DOMVl","wrapper":"main_wrapper__ppyIx","titleContainer":"main_titleContainer__Qq8iG","subtitleContainer":"main_subtitleContainer__l8+Zt"};